import { KALENDER_GET } from './reduxConstant';
import { createReducer } from '../../../../App/common/utilities/reducerUtils';

const initialState = {};

const kalenderGet = (state, payload) => {
  return { ...payload.kalender };
};

export default createReducer(initialState, {
  [KALENDER_GET]: kalenderGet,
});
